<template>
  <div v-if="commandeTlpe">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailCommandeTlpe.title', { code: commandeTlpe.code }) }}
                <b-tag v-if="getLibelleEtat"
                       type="has-background-subMenu"
                       class="has-text-white mgl-5px">
                  {{ getLibelleEtat }}
                </b-tag>
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <a ref="lienDownload"></a>
        <div class="level-right">
          <div class="buttons">
          <dropdownButton
            type="is-addOrEdit"
            class="mgr-2"
            :permission="constantes.COMMANDE_TLPE.maj"
            :actions="actionSecondary"
            @click="() => {
              $router.push({ name: 'm.gabed.commande_tlpe-edition',
                    params: { id: commandeTlpe.id}});
            }">
               {{ $t('general.button.edit') }}
          </dropdownButton>
            <button class="button" @click="$refs.dropdownEdition.toggle()">
              <div>
                <b-icon icon="file-download" class="mgr-10px" type="is-default"></b-icon>
                <b-dropdown ref="dropdownEdition" class="has-text-left" position="is-bottom-left">
                  <div slot="trigger">
                    <b-icon icon="chevron-down"
                            class="has-text-secondary-icon">
                    </b-icon>
                  </div>
                  <b-dropdown-item
                    @click="checkPermissions(constantes.COMMANDE_TLPE.editer) ?
                    editionCerfa() : showPopUp()">
                    {{ $t('general.popUpEdition.type.pdf') }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="checkPermissions(constantes.COMMANDE_TLPE.editer) ?
                    popUpEdition = true : showPopUp()">
                    {{ $t('general.popUpEdition.type.other') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="constantes.COMMANDE_TLPE.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
    </div>
    <div class="tab">
      <ul>
        <li :class="[{'is-active': activeTab === 'AppInfo'}]"
          @click="activeTab = 'AppInfo'">
          {{ $t('detailCommandeTlpe.tabs.quotation') }}
        </li>
        <li :class="[{'is-active': activeTab === 'AppEcheancier'}]"
           @click="activeTab = 'AppEcheancier'">
          {{ $t('detailCommandeTlpe.tabs.echeancierTlpe') }}
        </li>
      </ul>
    </div>
    <component
      :commandeTlpe="commandeTlpe"
      :is="activeTab"
    />
    <b-modal v-model="openPopUpGeneration"
             has-modal-card
             class="modal">
      <pop-up-prevention
        @no="openPopUpGeneration = false;"
        @yes="generationCommandeTlpe"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.oui')"
        :mess-header="$t('detailCommandeTlpe.generation.title')">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="openPopUpSuppresion"
             has-modal-card
             class="modal">
      <pop-up-prevention
        @no="openPopUpSuppresion = false;"
        @yes="suppression"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.oui')"
        :mess-header="$t('detailCommandeTlpe.suppression.title')">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :choiceEdition="choiceEdition"
        :error="errorEdition"
        @editionChoose="editionCourrier"
      >
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { DEVIS_COMMANDE_ETAT } from '@/configuration/devisConf';
import dropdownButton from '@/components/general/button/dropdownButton';
import breadcrumb from '@/components/general/breadcrumb';
import { COMMANDE_TLPE } from '@/configuration/gabed/permissionsGabedConf';
import { get, remove, regenererDeclarationTlpeFilDeLeau } from '@/api/gabed/commandeTlpe';
import messageErreur from '@/services/general/messageErreur';
import inProgress from '@/services/general/inProgress';
import editionCerfaAsync from '@/services/gabed/commandeTlpe/editionCerfaCommandeTlpe';
import piecesJointes from '@/components/general/piecesJointes';
import dotsMenu from '@/components/general/dotsMenu';
import AppInfo from '@/components/gabed/commandeTlpe/detail/infoCommandeTlpe';
import AppEcheancier from '@/components/gabed/commandeTlpe/detail/echeancierCommandeTlpe';
import popUpPrevention from '@/components/general/popUpPrevention';
import validation from '@/services/gabed/declaration/validation';
import { generationDeclarationsTlpeAsync } from '@/api/gabed/materiel';
import messageSucces from '@/services/general/messageSucces';
import popUpEdition from '@/components/factures/p_edition';
import {
  MONTAGE_AU_FIL_DE_L_EAU,
  DEMONTAGE_AU_FIL_DE_L_EAU, LISTE_CHOIX_EDITION_DECLARATIONS_TLPE,
} from '@/configuration/gabed/tlpe/tlpeConf';
import edition from '@/api/edition/index';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';

const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');

export default {
  data() {
    return {
      commandeTlpe: null,
      openPopUpGeneration: false,
      openPopUpSuppresion: false,
      errorPopUp: false,
      messagesErreurPopUp: [],
      activeTab: null,
      steps: [
        {
          name: this.$i18n.t('detailCommandeTlpe.steps.infoGenerales'),
          ref: '#generalInformations',
          active: true,
        },
        {
          name: this.$i18n.t('detailCommandeTlpe.steps.collectivite'),
          ref: '#collectivite',
          active: false,
        },
        {
          name: this.$i18n.t('detailCommandeTlpe.steps.infoMateriel'),
          ref: '#infoMateriel',
          active: false,
        },
        {
          name: this.$i18n.t('detailCommandeTlpe.steps.commentaire'),
          ref: '#commentaire',
          active: false,
        },
        {
          name: this.$i18n.t('detailCommandeTlpe.steps.piecesJointes'),
          ref: '#attachments',
          active: false,
        },
      ],
      constantes: {
        COMMANDE_TLPE,
      },
      popUpEdition: false,
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
    };
  },
  components: {
    breadcrumb,
    dropdownButton,
    piecesJointes,
    dotsMenu,
    popUpPrevention,
    popUpEdition,
    pieceJointeButton,
    AppInfo,
    AppEcheancier,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getLibelleEtat() {
      const etatFind = DEVIS_COMMANDE_ETAT.find((etat) => {
        return etat.code === this.commandeTlpe.etat;
      });
      return etatFind ? this.$i18n.t(etatFind.libelle) : null;
    },
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('detailCommandeTlpe.breadcrumb.liste'), route: { name: 'l.gabed.commande_tlpe' }, isActive: false },
        { title: this.$t('detailCommandeTlpe.breadcrumb.detail'), route: '', isActive: true },
      ];
    },
    choiceEdition() {
      return LISTE_CHOIX_EDITION_DECLARATIONS_TLPE.filter(l => {
        return l.libelle !== 'declarationTlpe.edition.declarationsTlpe';
      });
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('detailCommandeTlpe.action.generer'),
          action: () => { this.openPopUpGeneration = true; },
          permissionAction: COMMANDE_TLPE.maj,
        },
        {
          label: this.$t('general.button.delete'),
          action: () => { this.openPopUpSuppresion = true; },
          permissionAction: COMMANDE_TLPE.supprimer,
        },
      ];

      return actions;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    inProgress() {
      inProgress(this.$i18n);
    },
    async editionCerfa() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const commandesId = [];
        commandesId.push(this.commandeTlpe.id);
        await editionCerfaAsync(commandesId, this.$refs.lienDownload);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async generationCommandeTlpe() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const params = {
          societeId: this.commandeTlpe.societeId,
          annee: this.commandeTlpe.anneeDeclaration,
          typeDeclaration: this.commandeTlpe.typeDeclaration,
          declarantId: this.commandeTlpe.commercialId,
        };
        if (this.commandeTlpe.typeDeclaration === MONTAGE_AU_FIL_DE_L_EAU
          || this.commandeTlpe.typeDeclaration === DEMONTAGE_AU_FIL_DE_L_EAU) {
          await regenererDeclarationTlpeFilDeLeau({
            declarationId: this.commandeTlpe.id,
          });
        } else {
          await generationDeclarationsTlpeAsync({
            ...params,
            collectivitesIds: [this.commandeTlpe.intervenants[0].tiersId],
          });
        }
        this.openPopUpGeneration = false;
        messageSucces(this.$i18n.t('detailCommandeTlpe.messages.success.generation'));
        loadingComponent.close();
        this.$router.go(0);
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messagesErreurPopUp, []);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
      }
    },
    async suppression() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await remove(this.$route.params.id);
        messageSucces(this.$t('detailCommandeTlpe.messages.success.suppression'));
        this.openPopUpSuppresion = false;
        loadingComponent.close();
        await this.$router.push({ name: 'l.gabed.commande_tlpe' });
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async editionCourrier(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEdition.champsVide = [];
        this.errorEdition.messagesChampsVide = [];
        this.errorEdition.messages = [];
        this.errorEdition.haveError = false;
        const response = await edition({
          ids: [this.commandeTlpe.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: '',
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.activeTab = 'AppInfo';
      await this.setAttachmentContext({ module: 'Commande' });
      await this.setAttachmentElementId({ id: this.$route.params.id });
      this.commandeTlpe = (await get(this.$route.params.id)).data.result;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.commandeTlpe.code }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};

</script>
